import { render, staticRenderFns } from "./CampaignManagement.vue?vue&type=template&id=4b8559fc&scoped=true"
import script from "./CampaignManagement.vue?vue&type=script&lang=js"
export * from "./CampaignManagement.vue?vue&type=script&lang=js"
import style0 from "./CampaignManagement.vue?vue&type=style&index=0&id=4b8559fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8559fc",
  null
  
)

export default component.exports